import { Users, ToggleRight } from "lucide-react";
import SectionLayout from "../../lib/components/SectionLayout";
import { getCompanyDisplayName } from "../../lib/utils/featureAccess";

const ADMIN_TABS = [
  { to: "/admin", label: "Users", icon: Users, exact: true },
  { to: "/admin/features", label: "Feature Gating", icon: ToggleRight },
];

export default function AdminSection() {
  const companyName = getCompanyDisplayName();

  return (
    <SectionLayout
      companyName={companyName}
      title="Administration"
      subtitle="Manage users, roles & feature access"
      tabs={ADMIN_TABS}
    />
  );
}
